mutation UploadAndExtractZipToFolder($clientId: ID!, $folderId: ID!, $tmpPath: String!) {
    uploadAndExtractZipToFolder(clientId: $clientId, folderId: $folderId, tmpPath: $tmpPath) {
        id
        type
        url
        name
    }
}
